// extracted by mini-css-extract-plugin
export var deliveryRow = "_sv-a";
export var fixedHeight = "_sv-4";
export var freightLogo = "_sv-9";
export var fullWidth = "_sv-3";
export var priceColumn = "_sv-5";
export var radioSelected = "_sv-7";
export var radioUnselected = "_sv-6";
export var selectedOption = "_sv-2";
export var selectedOptionContainer = "_sv-1";
export var selection = "_sv-0";
export var tallSkeletonText = "_sv-8";